module.exports = __webpack_public_path__ + "static/img/gpt31.772224c7.png";